const Login = (props: any) => {
  return (
    <div className="popup">
    <div className="popup-box2">
      <div className="box2">
        {props.content}
      </div>
    </div>
    </div>
  );
};

export default Login;